export default {
  namespaced: true,

  state: () => ({
    employeeName: ''
  }),

  getters: {
    employeeName: (state) => state.employeeName
  },

  mutations: {
    SET_EMPLOYEE_NAME(state, name) {
      state.employeeName = name
    }
  },

  actions: {
    setEmployeeName({ commit }, name) {
      commit('SET_EMPLOYEE_NAME', name)
    }
  }
}